import React from 'react';
import { Container, Nav, NavItem, NavLink } from "reactstrap";
import classNames from "classnames";
import { NOTIFICATIONS_TAB_LINKS, NOTIFICATIONS_TABS } from "./constants";
import BaseLayoutWithCard from "../../../base/components/BaseLayoutWithCard";
import { isServiceEditable } from "../../../base/helpers/adminRolePermissions";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { NOTIFICATIONS_ROUTES } from "./config";
import History from "./History";
import Custom from "./Custom";
import Settings from "./Settings";

const breadcrumbs = {
  title: "Notifications", breadcrumbItems: []
};

export default function Notifications() {
  let navigate = useNavigate();

  const location = useLocation();
  const isMobileNotificationsEditable = isServiceEditable("Mobile Notifications");

  return (
    <Container fluid className="content">
      <BaseLayoutWithCard breadcrumbs={breadcrumbs}>
        <Nav tabs className="nav-tabs-custom mt-1">
          {Object.values(NOTIFICATIONS_TABS)
            .filter(label => isMobileNotificationsEditable || label !== "Custom notification")
            .map((label, index) => (
              <NavItem key={`navItem${index}`}>
                <NavLink
                  className={classNames(
                    {
                      active: location.pathname.endsWith(`/${NOTIFICATIONS_TAB_LINKS[label]}`)
                    },
                    "cursor-pointer py-1 mx-1"
                  )}
                  onClick={() => navigate(NOTIFICATIONS_TAB_LINKS[label])}
                >
                  <span>{label}</span>
                </NavLink>
              </NavItem>
            ))}
        </Nav>

        <Routes>
          <Route
            path={NOTIFICATIONS_ROUTES.HISTORY}
            element={<History/>}
          />

          <Route
            path={NOTIFICATIONS_ROUTES.CUSTOM}
            element={<Custom/>}
          />

          <Route
            path={NOTIFICATIONS_ROUTES.SETTINGS}
            element={<Settings/>}
          />

          <Route index element={<Navigate to={NOTIFICATIONS_ROUTES.HISTORY} replace />} />
        </Routes>
      </BaseLayoutWithCard>
    </Container>
  );
}
